export const engineeringTeamTypes = [
    {
        value: "13-03 - BLDG ENG",
        label: "13-03 - BLDG ENG",
    },
    {
        value: "13-05 - BLDG ENG Tukwila",
        label: "13-05 - BLDG ENG Tukwila",
    },
    {
        value: "13-06 - BLDG ENG Tacoma",
        label: "13-06 - BLDG ENG Tacoma",
    },
    {
        value: "13-07 - BLDG ENG Seattle",
        label: "13-07 - BLDG ENG Seattle",
    },
    {
        value: "13-09 - BLDG ENG Bellevue",
        label: "13-09 - BLDG ENG Bellevue",
    },
    {
        value: "13-18 - Seattle Engineering",
        label: "13-18 - Seattle Engineering",
    },
    {
        value: "13-28 - Portland Engineering",
        label: "13-28 - Portland Engineering",
    },
    {
        value: "13-48 - Arizona Engineering",
        label: "13-48 - Arizona Engineering",
    },
    {
        value: "23-68 - Bay Area Engineering",
        label: "23-68 - Bay Area Engineering",
    },
    {
        value: "23-69 - Sacramento Engineering",
        label: "23-69 - Sacramento Engineering",
    },
    {
        value: "23-78 - San Diego Engineering",
        label: "23-78 - San Diego Engineering",
    },
    {
        value: "23-88 - Orange County Engineering",
        label: "23-88 - Orange County Engineering",
    },
    {
        value: "23-98 - LA Engineering",
        label: "23-98 - LA Engineering",
    },
];
